import { USABILITY_SURVEY_BASE_URL } from 'pages/Portal/homeBannerConfig';
import type { CustomerMeResponse } from 'services/indexcServices';

/**
 * Mapeamento dos query params do link Indecx (pesquisa de usabilidade).
 * mercado, nucleo, rcr: sem campo dedicado em CustomerMeResponse — vazios até evolução da API.
 */

function digitsOnly(value: string): string {
  return value.replace(/\D/g, '');
}

function buildPhoneParam(userData?: CustomerMeResponse | null): string {
  const firstAddress = userData?.customerAddresses?.[0];
  const phoneContact = firstAddress?.contacts?.find(
    (c) => c.contactType === 'CELL' || c.contactType === 'PHONE'
  );

  const raw =
    phoneContact?.contact ||
    (userData?.phoneDdd && userData?.phoneNumber
      ? `${userData.phoneDdd}${userData.phoneNumber}`
      : '') ||
    (typeof localStorage !== 'undefined'
      ? localStorage.getItem('@UltragazEmpresarial:phone') || ''
      : '');

  let d = digitsOnly(raw);
  if (!d) return '';
  if (!d.startsWith('55') && d.length >= 10 && d.length <= 11) {
    d = `55${d}`;
  }
  return d;
}

export function buildUsabilitySurveyUrl(options: {
  userData?: CustomerMeResponse | null;
  consultantName?: string;
}): string {
  const { userData = null, consultantName = '' } = options;
  const firstAddress = userData?.customerAddresses?.[0];
  const emailContact = firstAddress?.contacts?.find(
    (c) => c.contactType === 'EMAIL'
  );

  const name =
    userData?.corporateName ||
    (typeof localStorage !== 'undefined'
      ? localStorage.getItem('@UltragazEmpresarial:customerName') || ''
      : '');

  const email =
    userData?.email ||
    emailContact?.contact ||
    (typeof localStorage !== 'undefined'
      ? localStorage.getItem('@UltragazEmpresarial:loginEmail') || ''
      : '');

  const phone = buildPhoneParam(userData);

  const codigo_erp =
    userData?.customerCode ||
    (typeof localStorage !== 'undefined'
      ? localStorage.getItem('@UltragazEmpresarial:customerCode') || ''
      : '');

  const segmento_gerencial = userData?.commercialRegion || '';
  const mercado = '';
  const nucleo = '';
  const consultor = consultantName;
  const rcr = '';

  const nome_do_contato =
    (typeof localStorage !== 'undefined'
      ? localStorage.getItem('@UltragazEmpresarial:userName') || ''
      : '') ||
    userData?.corporateName ||
    '';

  const params = new URLSearchParams();
  if (name) {
    params.set('name', name);
  }
  if (email) {
    params.set('email', email);
  }
  if (phone) {
    params.set('phone', phone);
  }
  if (codigo_erp) {
    params.set('codigo_erp', codigo_erp);
  }
  if (segmento_gerencial) {
    params.set('segmento_gerencial', segmento_gerencial);
  }
  if (mercado) {
    params.set('mercado', mercado);
  }
  if (nucleo) {
    params.set('nucleo', nucleo);
  }
  if (consultor) {
    params.set('consultor', consultor);
  }
  if (rcr) {
    params.set('rcr', rcr);
  }
  if (nome_do_contato) {
    params.set('nome_do_contato', nome_do_contato);
  }

  return `${USABILITY_SURVEY_BASE_URL}?${params.toString()}`;
}
